import base from './base.repository';
import base2 from './base2.repository';
export default {
    ...base,
    allAlertNotifications(filters, page){
        const params = {...filters, page: page};
        this.get(`comunications/alert-notifications${this.querify(params)}`);
        return this;
    },
    getAlertNotifications(profileSlug){
        this.get(`comunications/alert-notifications?profile=${profileSlug}`);
        return this;
    },
    saveAlert(alert) {
        this.post(`comunications/alert-notifications`, alert);
        return this;
    },
    updateAlert(alert, id) {
        this.put('comunications/alert-notifications/' + id, alert);
        return this;
    },
    deleteAlert(id){
        this.delete('comunications/alert-notifications/'+ id);
        return this;
    },
    setReadAccuse: (alertNotificationId, userId) => base2.post('comunications/read-accuses', {alertNotificationId, userId}),
    getReadAccuses: payload => base2.get('comunications/read-accuses', payload),
    getReadAccuseIndicators: alertNotificationId => base2.get(`comunications/read-accuses/${alertNotificationId}/indicators`)
}